// extracted by mini-css-extract-plugin
module.exports = {"containerOverOsano":"BaseUpsellModal_containerOverOsano__rRSrO","taller":"BaseUpsellModal_taller__h04Cx"};